<template>
  <v-card>
    <v-card-title>
      <span class="headline">Find a provider</span>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-card-text>
      <iframe :src="url" width="100%" height="1000" frameborder="0"></iframe>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      url: 'https://admin.metalocator.com/index.php?option=com_locator&view=directory&layout=combined_bootstrap&framed=1&tmpl=component&Itemid=17111&preview=1',
    };
  },
};
</script>
